import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/* eslint-disable  @typescript-eslint/no-explicit-any */
import * as React from 'react';
export function useDoOnce(cb) {
  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      done = _React$useState2[0],
      setDone = _React$useState2[1];

  return React.useCallback(function () {
    if (!done) {
      setDone(true);
      return cb.apply(void 0, arguments);
    }
  }, [cb, done]);
}